import { PaymentCycle } from './subscription.interface';

export const userTypes = ['admin', 'user', 'demo', 'pioneer'] as const;
export type UserType = (typeof userTypes)[number];

export interface Plan {
  id: number;
  paymentCycle: PaymentCycle;
  name: string;
  description: string;
  price: number;
  type: string;
  trialDays?: number;
  features: string[];
}

export interface CloseAccount {
  password: string;
}

export interface Profile {
  vat: number;
  name: string;
  plan: Plan;
  isSubscriptionPaid: boolean;
  nextBillingAt?: Date | string;
  hasPaymentMethod: boolean;
  trialEndsAt?: Date;
  isComplete: boolean;
  isInTrial: boolean;
  type: UserType;
  language: string;
  usedTrial: boolean;
  rules: any;
}

export interface UpdateLanguage {
  language: string;
}
